import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ProgressBarModule } from 'primeng/progressbar';
import { UploaderCentreComponent } from './uploader.centre.component';
import { UploaderDetailComponent } from './uploader.detail.component';


@NgModule({
    imports: [
        CommonModule,
        DialogModule,
        ProgressBarModule
    ],
    declarations: [
        UploaderCentreComponent,
        UploaderDetailComponent
    ],
    exports: [
        UploaderCentreComponent,
        UploaderDetailComponent
    ],
    providers: [],
})
export class UploaderModule { }
